// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"ccfb4457","453":"14f65c96","565":"1ca281c8","879":"887e30b5","946":"c8027cd4"}[chunkId] + ".chunk.js";
};